import React, { Component } from "react";
import PropTypes from "prop-types";
import * as images from "../../constants/Images";
//import ProfileService from "../../services/ProfileService";
import "./Profile.css";
import CommonService from "../../services/CommonService";
import ProfileService from "../../services/ProfileService";
import Loadspinner from "../../common/Loadspinner";
import { toast } from "react-toastify";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";
import CommonConstants from "../../constants/CommonConstants";

const EXCLUDE_CATEGORIES = ["Others", "NA"];

class AddInterests extends Component {
  constructor(props) {
    super(props);
    this.state = { list: [], categoryList: [], isLoading: false };
  }

  componentDidMount() {
    this.getList();
  }

  getList = async () => {
    const res = await CommonService.getSystemList();

    if (res) {
      this.setState({ list: res });
    }
    this.setList();
  };

  setList = () => {
    const { selected } = this.props;
    const { list } = this.state;
    list.map((item) => (item.isSelected = false));

    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < selected.length; j++) {
        if (list[i].id == selected[j].id) {
          list[i].isSelected = true;
        }
      }
    }
    this.setState({ categoryList: list });
  };

  setUnchecked = (id) => {
    const { categoryList } = this.state;
    categoryList.map((item) => (item.id == id ? (item.isSelected = !item.isSelected) : null));
    this.setState({ categoryList });
  };

  updateInterests = async () => {
    const { categoryList } = this.state;
    let idList = [];

    categoryList.map((item) => (item.isSelected ? idList.push(item.id) : null));

    let idString = idList.toString();
    this.setState({ isLoading: true });
    const res = await ProfileService.updateInterests(idString);
    if (res) {
      toast("Updated");
    }
    //logEvent(analytics(), 'addInterest')
    this.setState({ isLoading: false });
    this.props.updated();
  };

  render() {
    const { categoryList, isLoading } = this.state;
    const isOneInterestSelected = categoryList.some((item) => item.isSelected === true);

    return (
      <div>
        <Loadspinner filename="AddInterests.js" isLoading={isLoading} isMiddle="false" />
        <img src={images.add_icon} className="profile-card-img" data-bs-toggle="modal" data-bs-target="#addInterests" onClick={this.getList} />
        <div
          className="modal fade"
          id="addInterests"
          // data-bs-backdrop="static"
          // data-bs-keyboard="false"
          aria-labelledby="addInterestsLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm">
            <div className="modal-content" style={{ borderRadius: "10px" }}>
              <div className="modal-header">
                <img src={images.interests_red} className="profile-card-header-img" />
                <h5 className="modal-title popup-header" style={{ marginRight: "auto" }}>
                  Interests
                </h5>
                {/* <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button> */}
              </div>
              <div className="modal-body">
                {!isOneInterestSelected && <small className="text-danger">Please select atleast one interest</small>}
                {categoryList
                  .filter((item) => !EXCLUDE_CATEGORIES.includes(item.system_desc))
                  .map((system) => (
                    <div key={system.id}>
                      <input
                        type="checkbox"
                        className="form-check-input popup-checkbox"
                        checked={system.isSelected}
                        onChange={() => this.setUnchecked(system.id)}
                        autoComplete={CommonConstants.autoCompleteInput}
                      />
                      <label className="form-check-label" style={{ fontSize: "13px" }}>
                        {system.system_desc}
                      </label>
                    </div>
                  ))}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn popup-submit-btn" data-bs-dismiss="modal" onClick={this.updateInterests} disabled={!isOneInterestSelected}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddInterests;

AddInterests.propTypes = {
  selected: PropTypes.array,
  updated: PropTypes.func,
};

//  {list.map((system) => (
//                   <div key={system.id}>
//                     <h6>{system.system_desc}</h6>
//                     {system.master_subsystems.map((subsystem) => (
//                       <div key={subsystem.id}>
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="exampleCheck1"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="exampleCheck1"
//                         >
//                           {subsystem.subsystem_desc}
//                         </label>
//                       </div>
//                     ))}
//                   </div>
//                 ))}
